export default {"src":"/_next/static/media/interview_roadmap.440c9b71.svg","height":314,"width":696,"blurWidth":0,"blurHeight":0};